import Vue from "vue";
import App from "./App.vue";
import routes from "./router";
import store from "./store/index";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
// font awesome
import "vue-awesome/icons";
// Import TinyMCE
import tinymce from "tinymce/tinymce";

// Default icons are required for TinyMCE 5.3 or above
import "tinymce/icons/default";

// A theme is also required
import "tinymce/themes/silver";

// Any plugins you want to use has to be imported
import "tinymce/plugins/paste";
import "tinymce/plugins/link";

// Initialize the app
tinymce.init({
  selector: "#tiny",
  plugins: ["paste", "link"]
});

Vue.component("tinymce", tinymce);
Vue.use(require("vue-moment"));
Vue.config.productionTip = false;

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  mode: "history"
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    console.log('store.state', store.state)
    if (store.state.Login.token) {
      // let vuex = JSON.parse(window.localStorage.getItem('vuex'));
      // Service.AuthAPI.getUserDetail(store.state.Login.token).then((res) => {
      //   vuex.Login.userDetail = res;
      //   window.localStorage.setItem('vuex', JSON.stringify(vuex))
      // });
      next();
    } else {
      console.log('else')
      window.localStorage.removeItem("vuex");
      window.location = '/login'
    }
  } else {
    next(); // make sure to always call next()!
  }
});
//style scss
import "./assets/css/variables.scss";
import "./assets/css/font.scss";
import "./main.scss";
import "./assets/css/switch.css";
import VueRouter from "vue-router";
import Service from "./Services";
/* eslint-disable */
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');

